import http from './api'
import { RestaurantOrder, RestaurantOrderStatus } from '../types/order'

export interface AddOrderItemData {
  menuItemId?: string
  dishId?: string
  name?: string
  unitPrice?: number
  quantity: number
}

class OrderService {
  async listOrders(
    restaurantId: string,
    status?: RestaurantOrderStatus,
  ): Promise<RestaurantOrder[]> {
    const query = status ? `?status=${status}` : ''
    const response = await http.get(`/restaurants/${restaurantId}/orders${query}`)
    return response.data
  }

  async getOrder(restaurantId: string, orderId: string): Promise<RestaurantOrder> {
    const response = await http.get(`/restaurants/${restaurantId}/orders/${orderId}`)
    return response.data
  }

  async createOrder(
    restaurantId: string,
    data: { tableLabel?: string; note?: string },
  ): Promise<RestaurantOrder> {
    const response = await http.post(`/restaurants/${restaurantId}/orders`, data)
    return response.data
  }

  async updateOrder(
    restaurantId: string,
    orderId: string,
    data: { status?: RestaurantOrderStatus; tableLabel?: string; note?: string },
  ): Promise<RestaurantOrder> {
    const response = await http.patch(
      `/restaurants/${restaurantId}/orders/${orderId}`,
      data,
    )
    return response.data
  }

  async addItem(
    restaurantId: string,
    orderId: string,
    data: AddOrderItemData,
  ): Promise<RestaurantOrder> {
    const response = await http.post(
      `/restaurants/${restaurantId}/orders/${orderId}/items`,
      data,
    )
    return response.data
  }

  async updateItem(
    restaurantId: string,
    orderId: string,
    itemId: string,
    quantity: number,
  ): Promise<RestaurantOrder> {
    const response = await http.patch(
      `/restaurants/${restaurantId}/orders/${orderId}/items/${itemId}`,
      { quantity },
    )
    return response.data
  }

  async removeItem(
    restaurantId: string,
    orderId: string,
    itemId: string,
  ): Promise<RestaurantOrder> {
    const response = await http.delete(
      `/restaurants/${restaurantId}/orders/${orderId}/items/${itemId}`,
    )
    return response.data
  }
}

const orderService = new OrderService()
export default orderService
